/* Copyright (c) 2025 MOCA Systems, Inc.  All rights reserved. */
// projectId saved on project list
export const SELECTED_PROJECT_ID = 'selectedProjectId';
// sort and filter saved on side-nav
export const FILTER_STATES = 'selectedFilterStates';
